import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c204d594&scoped=true&"
import script from "./detailchapterview.js?vue&type=script&lang=js&"
export * from "./detailchapterview.js?vue&type=script&lang=js&"
import style0 from "../detailMangaView.scss?vue&type=style&index=0&id=c204d594&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c204d594",
  null
  
)

export default component.exports